import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

import EditIcon from '@mui/icons-material/Edit';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import BarChartIcon from '@mui/icons-material/BarChart';

const Chronos = () => {
    return (
        <Grid container spacing={3} className="hermes-container">
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <EditIcon /> Define
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Create and manage process definitions, triggers and rulesets.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Define Process
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <PeopleAltOutlinedIcon /> Assign
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Assign processes, queues and approvals to users or roles.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Manage Assignments
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <DescriptionOutlinedIcon /> Track
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Track ongoing and completed processes, view logs and audit history.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Managed Processes
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <ElectricBoltIcon /> Automate
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Enable automation through AI agents, event triggers and rules.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Manage Automation
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Card>
                    <MDBox p={2}>
                        <MDTypography component="h6" variant="button" fontWeight="bold" color="dark" mb={1}>
                            <BarChartIcon /> Optimize
                        </MDTypography>
                        <MDTypography component="p" variant="button" fontWeight="light" color="dark" mb={2}>
                            Analyze workflow velocity, surface bottlenecks, and continuously evolve with AI-driven optimizations.
                        </MDTypography>
                        <MDButton variant="outlined" color="light">
                            Optimize Processes
                        </MDButton>
                    </MDBox>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Chronos;